import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { ReactComponent as ExpensesIcon } from '../../../../../../assets/icons/expense-icons/shipments.svg'
import { ReactComponent as FoodIcon } from '../../../../../../assets/icons/expense-icons/food.svg'
import { ReactComponent as MaterialIcon } from '../../../../../../assets/icons/expense-icons/material.svg'

export default function index({ t, selectedCategory, editing, setSelectedCategory }) {
  const categories = [
    {
      id: 1,
      name: t('food'),
      value: 'Food',
      icon: <FoodIcon className={styles.icon} />
    },
    {
      id: 2,
      name: t('material'),
      value: 'Material',
      icon: <MaterialIcon className={styles.icon} />
    },
    {
      id: 3,
      name: t('tech'),
      value: 'Tech',
      icon: <MaterialIcon className={styles.icon} />
    },
    {
      id: 4,
      name: t('other'),
      value: 'Other',
      icon: <ExpensesIcon className={styles.icon} />
    }
  ]

  const [opMenu, setOpMenu] = useState(false)
  const menuRef = useRef(null)

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div className={styles.container} ref={menuRef}>
        <label className={styles.entry_label} htmlFor='name'>
          {t('category')}
        </label>
        <div className={`${styles.op_selector_container} ${opMenu ? styles.active_menu : ''}`}>
          <input
            type='text'
            id='name'
            name='name'
            defaultValue={selectedCategory?.name || ''}
            placeholder='Select operation'
            className={styles.selector_input}
            autoComplete='off'
            onClick={() => setOpMenu(!opMenu)}
            disabled={editing && selectedCategory}
          />
          <div className={styles.op_menu_container}>
            <ul className={styles.op_menu_list_container}>
              {categories?.map((cat) => (
                <li
                  key={cat.id}
                  className={styles.op_menu_item}
                  onClick={() => {
                    setSelectedCategory(cat)
                    setOpMenu(false)
                  }}
                >
                  {cat.icon}
                  <span className={styles.op_menu_text}>{cat.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
